import { render } from "./Cobroclientemodal.vue?vue&type=template&id=3adc22d0&scoped=true"
import script from "./Cobroclientemodal.vue?vue&type=script&lang=js"
export * from "./Cobroclientemodal.vue?vue&type=script&lang=js"

import "./Cobroclientemodal.vue?vue&type=style&index=0&id=3adc22d0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adc22d0"]])

export default __exports__